import React, { Component } from 'react'
import './style.css';
import parse from 'html-react-parser';
import ERROR_MESSAGES from './ErrorMessages';
import config from './config-helper';

export class Landing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            caseNumber: '',
            caseNumberError: '',
            licensePlate: '',
            licensePlateError: '',
            isVrnReadOnly: false,
            validationSuccess: false,
            isAPIError: false,
            isSubmittng: false,
            caseData: null,
            captchaToken: null,
            captchaError: '',
            rateLimitError: null,
            apiError: ''
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.renderTurnstile = this.renderTurnstile.bind(this);
        this.rerenderTurnstile = this.rerenderTurnstile.bind(this);
        this.renderBalance = false;
        this.turnstileContainer = React.createRef();
        this.widgetId = null;
        this._turnstilePoll = null;
    }

    componentDidMount() {
        if (window.turnstile) {
            this.renderTurnstile();
        } else {
            this._turnstilePoll = setInterval(() => {
                if (window.turnstile) {
                    clearInterval(this._turnstilePoll);
                    this.renderTurnstile();
                }
            }, 100);
        }
    }

    componentWillUnmount() {
        clearInterval(this._turnstilePoll);
        if (this.widgetId !== null && window.turnstile) {
            window.turnstile.remove(this.widgetId);
        }
    }

    renderTurnstile() {
        if (this.turnstileContainer.current) {
            this.widgetId = window.turnstile.render(this.turnstileContainer.current, {
                sitekey: config.TURNSTILE_SITE_KEY,
                theme: 'auto',
                callback: (token) => this.setState({ captchaToken: token, captchaError: '' }),
                'expired-callback': () => this.setState({ captchaToken: null })
            });
        }
    }

    // The Turnstile container is removed from the DOM when the spinner shows (isSubmittng: true)
    // and a fresh empty div is created when the form remounts. Calling turnstile.reset() against
    // the stale widget ID has no effect on the new element. This method removes the old widget and
    // mounts a new one in the current container. It must be called via a setState callback so the
    // DOM has already updated before the widget is rendered.
    rerenderTurnstile() {
        if (this.widgetId !== null && window.turnstile) {
            window.turnstile.remove(this.widgetId);
            this.widgetId = null;
        }
        this.renderTurnstile();
    }


    handleSubmit(e) {
        e.preventDefault();
        this.validateInput();
        if (this.state.validationSuccess) {
            this.setState({ isSubmittng: true, captchaError: '', rateLimitError: null });
            var url = '/api/case/balance?caseNumber=' + encodeURIComponent(this.state.caseNumber)
                + '&licensePlate=' + encodeURIComponent(this.state.licensePlate)
                + '&cfTurnstileResponse=' + encodeURIComponent(this.state.captchaToken);
            fetch(url)
                .then(res => {
                    if (res.status === 429) {
                        this.setState(
                            { rateLimitError: ERROR_MESSAGES.RATE_LIMIT_EXCEEDED, captchaToken: null, isSubmittng: false },
                            this.rerenderTurnstile
                        );
                        return null;
                    }
                    return res.json();
                })
                .then(data => {
                    if (data === null) return;
                    if (data.IsInvalidLicensePlate) {
                        this.setState(
                            { licensePlateError: ERROR_MESSAGES.INVALID_LICENSE_PLATE, captchaToken: null, isSubmittng: false },
                            this.rerenderTurnstile
                        );
                        return;
                    }
                    if (data.ResponseError) {
                        if (data.ResponseStatus === 400) {
                            this.setState(
                                { captchaError: ERROR_MESSAGES.CAPTCHA_VERIFICATION_FAILED, captchaToken: null, isSubmittng: false },
                                this.rerenderTurnstile
                            );
                        } else {
                            this.setState(
                                { apiError: data.ResponseError, captchaToken: null, isSubmittng: false },
                                this.rerenderTurnstile
                            );
                        }
                        return;
                    }
                    this.redirectToBalance(data);
                })
                .catch((err) => {
                    console.log("Error while fetchig data from API: " + err.message);
                    this.setState({
                        isAPIError: true
                    });
                    this.setState({ isSubmittng: false });
                });
        }
    }

    validateInput() {
        let caseNumberError = "";
        let licensePlateError = "";

        if (!this.state.caseNumber) {
            caseNumberError = ERROR_MESSAGES.NO_CASE_NUMBER;
        }
        else {
            const pattern = /\s*(([AaCcFfUuRrSsNn](\d{2}-\d{4}-\d{4}|\d{10}))|([MmDd](\w{2}-\w{4}-\w{3}|\w{9})))\s*/;
            const result = pattern.test(this.state.caseNumber);
            if (result === false) {
                caseNumberError = ERROR_MESSAGES.INVALID_CASE_NUMBER;
            }
        }

        if (!this.state.isVrnReadOnly && !this.state.licensePlate) {
            licensePlateError = ERROR_MESSAGES.NO_LICENSE_PLATE;
        }

        if (caseNumberError || licensePlateError) {
            this.setState({ caseNumberError, licensePlateError, validationSuccess: false });
        }
        else {
            this.state.validationSuccess = true;
        }
    }

    redirectToBalance(data) {
        if (this.state.validationSuccess)
            this.props.history.push("/Balance", data);
    }


    handleInputChange(event) {
        const target = event.target;
        var value = target.value;
        const name = target.name;

        if (name === 'caseNumber') {
            if (value.trimStart().toUpperCase().startsWith('N')) {
                this.setState({ [name]: value, licensePlate: 'N/A', isVrnReadOnly: true, apiError: '' });
            } else {
                const resetVrn = this.state.isVrnReadOnly ? { licensePlate: '', isVrnReadOnly: false } : {};
                this.setState({ [name]: value, ...resetVrn, apiError: '' });
            }
        } else if (name === 'licensePlate') {
            this.setState({ [name]: value, licensePlateError: '', apiError: '' });
        } else {
            this.setState({ [name]: value });
        }
    }

    render() {
        if (this.state.isAPIError) {
            return (
                <div className="col" tabIndex="0" role="error">
                    <label> {parse(ERROR_MESSAGES.API_ERROR)}</label>
                </div>
            );
        }
        else if (this.state.isSubmittng) {
            return (
                <div className="d-flex justify-content-center">
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            );
        }
        else {
            return (
                <div>
                    <form>
                        <div className="row">
                            <div className="col-md-4">
                                <label className="font-weight-bold" tabIndex="0">Reference Number:<br /><i>Uimhir Thagartha:</i> </label>
                            </div>
                            <div className="form-group col-md-8">
                                <input type="text" name="caseNumber" value={this.state.caseNumber} aria-label="Reference Number Input Field" onChange={this.handleInputChange} />
                                <label className="text-danger validation-error" tabIndex="0">{parse(this.state.caseNumberError)}</label>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <label className="font-weight-bold" tabIndex="0">Vehicle Registration Number:<br /><i>Cláruimhir na Feithicle:</i></label>
                            </div>
                            <div className="form-group col-md-8">
                                <input type="text" name="licensePlate" value={this.state.licensePlate} aria-label="Vehicle Registration Number Input Field" onChange={this.handleInputChange} readOnly={this.state.isVrnReadOnly} style={this.state.isVrnReadOnly ? { backgroundColor: '#e9ecef' } : undefined} />
                                <label className="text-danger validation-error" tabIndex="0">{parse(this.state.licensePlateError)}</label>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col d-flex align-items-start">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#0d6efd" className="mr-2 flex-shrink-0" style={{ marginTop: '2px' }} viewBox="0 0 16 16" aria-hidden="true">
                                    <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm8.93 4.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
                                </svg>
                                <p tabIndex="0" className="mb-0">
                                    A Vehicle Registration Number is not required <br />if your reference starts with the letter N<br /><br />
                                    <span className="font-italic">Ní gá Uimhir Chlárúcháin Feithicle a bheith agat<br /> má thosaíonn do thagairt leis an litir N</span>
                                </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <div ref={this.turnstileContainer}></div>
                                <label className="text-danger validation-error" tabIndex="0">{parse(this.state.captchaError)}</label>
                                {this.state.rateLimitError && <label className="text-danger validation-error" tabIndex="0">{parse(this.state.rateLimitError)}</label>}
                            </div>
                        </div>
                        {this.state.apiError && (
                            <div className="row mt-2">
                                <div className="col text-danger" tabIndex="0" role="alert">
                                    <label>{parse(this.state.apiError)}</label>
                                </div>
                            </div>
                        )}
                        <div className="row">
                            <div className="col">
                                <button type="submit" className="btn btn-secondary" aria-label="Submit Button" onClick={this.handleSubmit} disabled={!this.state.captchaToken || this.state.isSubmittng}>Submit</button>
                                <br />
                                <p className="font-weight-bold font-italic" tabIndex="0">Cuir Faoi Bhráid</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col" tabIndex="0" >
                                To make a payment please enter your Case Reference Number which you<br />
                                will find in the top right hand corner of your notice under “Ref No”.
                                <br />
                                <br />
                                <span className="font-italic">Chun íocaíocht a dhéanamh cuir isteach Uimhir Thagartha do Cháis le do thoil,<br />
                                    gheobhaidh tú í seo sa chúinne uachtarach ar dheis ded' fhógra faoi “Ref No”.</span>
                            </div>
                        </div>
                    </form>
                </div>
            );
        }
    }
}